import {createStyles, makeStyles} from '@material-ui/core/styles/';

export const useStyles = makeStyles((theme) =>
  createStyles({
    showTimer: {
      textAlign: 'center',
      fontSize: '24px',
      fontFamily: theme.typography.fontFamily
    },

    modalOuter: {
      '& .MuiPaper-rounded': {
        boxShadow: 'none !important',
        borderRadius: 0,

        '&:before': {
          display: 'none'
        }
      }
    },
    modalHead: {
      position: 'relative',
      padding: '0px 0px 20px 0px'
    },
    modalClose: {
      position: 'absolute',
      bottom: '20px',
      right: '0px'
    },
    modalNotification: {
      '& svg': {
        verticalAlign: 'middle'
      }
    },
    modalTitle: {
      padding: '0 24px'
    },
    modalFooter: {
      justifyContent: 'flex-end',
      paddingLeft: '0px'
    }
  })
);
